module.exports = __webpack_public_path__ + "img/gabinete.bada82f2.png";